/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_Field_ControlInputs */

const vi_grower_area_camera_field_control = /** @type {(inputs: Grower_Area_Camera_Field_ControlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token điều khiển PTZ`)
};

/**

* @param {Grower_Area_Camera_Field_ControlInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_field_control = /** @type {((inputs?: Grower_Area_Camera_Field_ControlInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_Field_ControlInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_field_control(inputs)
});